// extracted by mini-css-extract-plugin
export default {"Container":"Styles_Container__p6fKT","tesWa":"Styles_tesWa__wi9yN","LogoWrapper":"Styles_LogoWrapper__IDUPw","banner":"Styles_banner__5LoE3"};